import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

class AppContentComponent extends Component {
	render() {
		return (
			<div className="medium-9 cell content-wrapper cell-block-container">
				<div className="grid-x grid-padding-x grid-padding-y">
					<div className="medium-12 cell cell-block-y">
						{ this.props.children }
					</div>
				</div>
			</div>
		)
	}
}

export default withRouter(connect()(AppContentComponent));


// WEBPACK FOOTER //
// ./src/application/templates/content.js